import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "../../dashboard/claimLitigation/litigation.scss";
import {
  fetchFlagDetails,
  updateFlag,
} from "./litigationApi";
import AsteriskSymbol from "../../reusableComponents/AsteriskSymbol";
import { flagClaimsMaxLength, LITIGATION, Litigationvalidtypes, POTENTIAL_LITIGATION, REGEX } from "../../consts";
import { Button, Modal, ModalBody, ModalFooter } from "react-bootstrap";
import LoadingPage from "../../reusableComponents/loader/loadingPage";
import FileUpload from "../../utilsComponent/fileUpload";
import { formatDocumentDetails } from "./helper";
import FlagClaimsAccordion from "../../utilsComponent/FlagClaimsAccordion";

const PotentialLitigation = (props) => {
  const { claimDetailCookie, roleDataCookie, getClaimDetails } = props;
  const [loading, setLoading] = useState(false);
  const [flagPotentialLitigation, setFlagPotentialLitigation] = useState(false);
  const [remarksInModal, setRemarksInModal] = useState("");
  const [potentialLitigationModal, setPotentialLitigationModal] = useState(false);
  const [previousFlagPotentailLitigation, setPreviousFlagPotentialLitigation] = useState(false);
  const [addedFiles, setAddedFiles] = useState([]);
  const [rows, setRows] = useState([]);
  const isLitigationFlagged = claimDetailCookie?.flags?.some(f => f.flagId === LITIGATION)

  useEffect(() => {
    if (claimDetailCookie?.claimNo) {
      getPotentialLitigationDetails();
    }
  }, [claimDetailCookie?.claimNo]);

  const getPotentialLitigationDetails = () => {
    setLoading(true);
    fetchFlagDetails(claimDetailCookie?.claimNo, POTENTIAL_LITIGATION, setLoading)
      .then((data) => {
      setRows(data?.records)
      if (!data?.records?.length) {
        setFlagPotentialLitigation(false);
        setPreviousFlagPotentialLitigation(false);
      } else {
        const latestActivity = data?.records[0]?.activityName || "";
        if (latestActivity === "Potential Litigation Unflagged") {
          setFlagPotentialLitigation(false);
          setPreviousFlagPotentialLitigation(true);
        } else if (latestActivity === "Potential Litigation Flagged" || latestActivity === "Potential Litigation Re-flagged") {
          setFlagPotentialLitigation(true);
          setPreviousFlagPotentialLitigation(true);
        }
      }
      })
      .catch((error) => {
        console.error("Error fetching potential litigation details:", error);
        setFlagPotentialLitigation(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleFlagPotentialLitigation = () => {
    const isFlagLitigationChecked = !flagPotentialLitigation;
    setPreviousFlagPotentialLitigation(flagPotentialLitigation);
    setFlagPotentialLitigation(isFlagLitigationChecked);
    setPotentialLitigationModal(true);
  };
  const submitPotentialLitigation = async () => {
    if (
      claimDetailCookie.assignedTo === "Unassigned" ||
      !claimDetailCookie.assignedTo
    ) {
      toast.error("Please Assign Claims Handler.");
      return;
    }
    if (!remarksInModal) {
      toast.error("Please enter remarks");
      return;
    }
    setLoading(true);
    const response = await updateFlag({
      claimId: claimDetailCookie.claimNo,
      flagId: POTENTIAL_LITIGATION,
      userId: roleDataCookie?.userID,
      remarks: remarksInModal,
      documentId: addedFiles.map((list) => list.id)
    },setLoading);
    setLoading(false);
    toast.success(response);
    getClaimDetails(claimDetailCookie?.claimNo);
    getPotentialLitigationDetails();
    setRemarksInModal("");
    setPotentialLitigationModal(false);
    setAddedFiles([]);
  };
  const handleModalClose = () => {
    setFlagPotentialLitigation(previousFlagPotentailLitigation);
    setPotentialLitigationModal(false);
    setRemarksInModal("");
    setAddedFiles([]);
  };
  return loading ? (
    <LoadingPage />
  ) : (
    <div>
      <div>
        <div className="potential">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="flagPotentialLitigation"
              checked={flagPotentialLitigation}
              onClick={handleFlagPotentialLitigation}
              disabled={isLitigationFlagged}
              readOnly
            />
            <label
              className="form-check-label mb-3"
              htmlFor="flagPotentialLitigation"
            >
              Flag a Potential Litigation
            </label>
          </div>
          {potentialLitigationModal && (
            <Modal
              show={potentialLitigationModal}
              isOpen={potentialLitigationModal}
              centered={true}
              backdrop={"static"}
              className="fraud-modal-width"
            >
              <ModalBody>
                <div>
                  <label>
                    <h6>
                      Remarks <AsteriskSymbol />
                    </h6>
                  </label>
                </div>
                <div>
                  <textarea
                    className="remarksPotential"
                    placeholder="Please enter remarks"
                    value={remarksInModal}
                    onChange={(e) => {
                      const potentialLitigationRemarks = e.target.value
                        .replace(REGEX.ALPHANUM_SPACE, "")
                        .slice(0, flagClaimsMaxLength);
                      setRemarksInModal(potentialLitigationRemarks);
                    }}
                  ></textarea>
                  <div className="remarks-text-info right">
                    <p>
                      {remarksInModal.length}/{flagClaimsMaxLength}
                    </p>
                  </div>
                  <FileUpload
                    validtype={Litigationvalidtypes}
                    addedFiles={addedFiles}
                    setAddedFiles={setAddedFiles}
                    text={"Upload File"}
                    module="litigation"
                    roleDataCookie={roleDataCookie}
                    doctypeName="litigation"
                    tran_id={claimDetailCookie?.claimNo}
                  />
                </div>
              </ModalBody>
              <ModalFooter className="justify-content-center">
                <Button variant="outline-danger" onClick={handleModalClose}>
                  Cancel
                </Button>
                <Button
                  variant="outline-success"
                  onClick={() => submitPotentialLitigation()}
                >
                  Submit
                </Button>
              </ModalFooter>
            </Modal>
          )}
          <FlagClaimsAccordion
            rows={rows}
            formatDocumentDetails={formatDocumentDetails}
          />
        </div>
      </div>
    </div>
  );
};

export default PotentialLitigation;
